import React from "react";
import { Button } from "../../../button";
import { Image } from "../../../image";
import { PollOption } from "../../../poll";
import { FormattedMessage } from "react-intl";
import { PollModal } from "../../../poll-modal";
import { usePollContext } from "../../../../stores/poll";

import styles from "../styles.modules.scss";

export type PollSlideType = {
    type: "pollEntry";
    id: string;
    background: ImageSourceSets;
    title: string;
    pollTitle: string;
    hideTitle: boolean;
    options: PollOption[];
    pollTargets: [];
    pollDescription: string;
    targeting?: Targeting;
    relatedMedia?: RelatedMedia[];
};

export const PollSlide = ({ slide }: { slide: PollSlideType }) => {
    const {
        background,
        title,
        hideTitle,
        id,
        pollTitle,
        options,
        pollTargets,
        pollDescription,
        targeting,
    } = slide;
    const {
        state,
        canVote,
        hasVoted,
        actions: { openModal, closeModal, /*getVote,*/ refreshPollInfo },
    } = usePollContext();

    React.useEffect(() => {
        Promise.all([/*getVote(id), */ refreshPollInfo(id)]);
    }, [id]);

    const voteCta = {
        className: "vote-button",
        label: <FormattedMessage id="globalText.langVoteDefaultButtonLabel" />,
        onClick: () => openModal(id),
    };

    const showResultsCta = {
        className: "show-results-button",
        label: <FormattedMessage id="globalText.langVoteResultsButtonLabel" />,
        onClick: () => openModal(id),
    };

    const showVoteCta = {
        className: "show-results-button",
        label: <FormattedMessage id="globalText.langVoteCheck" />,
        onClick: () => openModal(id),
    };

    const getCta = ():
        | typeof voteCta
        | typeof showResultsCta
        | typeof showVoteCta => {
        if (hasVoted(id) && state.polls[id]?.status !== "closed") {
            return showVoteCta;
        }

        const useVoteCta =
            (canVote(id) && state.polls[id]?.status !== "closed") ||
            state.polls[id]?.status === "open-hidden";

        return useVoteCta ? voteCta : showResultsCta;
    };

    const cta = getCta();

    const modalProps = {
        pollId: id,
        pollTitle,
        isOpen: id === state.activePollId,
        onClose: () => closeModal(),
        options,
        pollTargets,
        pollDescription,
        targeting,
    };

    return (
        <>
            <div className={`slide vote ${styles.slide}`}>
                <div className={`content ${styles.content}`}>
                    {background && (
                        <div className={`image ${styles.image}`}>
                            <Image sources={background} cover />
                        </div>
                    )}

                    {title && !hideTitle && (
                        <>
                            <div className={`filter ${styles.filter}`} />

                            <div
                                className={`title ${styles.title}`}
                                data-title={title}
                            >
                                {title}
                            </div>
                        </>
                    )}

                    <div className={`wrapper ${styles.wrapper}`}>
                        <div
                            className={`ctas single ${styles.ctas} ${cta.className}`}
                        >
                            <Button onClick={cta.onClick}>
                                <span className="buttonTextWrapper">
                                    {cta.label}
                                </span>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>

            <PollModal {...modalProps} />
        </>
    );
};
